import React from "react";
import ChecklistCatalog from "../../components/checklist/ChecklistCatalog";

export default function TherapistChecklist() {
  return <ChecklistCatalog type="therapist" />;
}
